import { AppImages } from "app/appImages";
import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { TopicAutoCompleteDataModel } from "components/MprcAutoComplete/AutoCompleteDataModel";
import { TopicCategory } from "generated/CoreApi_v1";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

interface Props extends Omit<IAutoCompleteProps, 'onGetSuggestions' | "emptyThumbnail" | "onChange"> {
    onChange: (item: TopicAutoCompleteDataModel[]) => void;
    isInterestAssigment?: boolean;
    applyKnowledgeTest?: boolean;
    categories?: TopicCategory[];
}

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de tópicos
 * @param props
 */
export const TopicAutoComplete: React.FC<Props> = ({ onChange, categories, ...props }) => {

    const api = useCoreApi();

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.suggestions.topics({
                searchText: searchText,
                pageNumber: pageNumber,
                pageSize: pageSize,
                isInterestAssigment: props.isInterestAssigment ?? false,
                applyKnowledgeTests: props.applyKnowledgeTest ?? false,
                categories: categories ?? null,
                ignoreSelectionHistory: true
            }, { signal })
                .then(result => {
                    resolve({
                        items: result.data.items as AutoCompleteDataModel[],
                        totalRows: result.data.totalRows
                    });
                })
                .catch(error => {
                    if (!isCanceledError(error)) {
                        resolve({ items: [], totalRows: 0 });
                        if (props.onError) props.onError(props.error);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            emptyThumbnail={AppImages.TopicThumbnail}
            onGetSuggestions={getSuggestions}
            onChange={(itens) => onChange(itens as TopicAutoCompleteDataModel[])}
        />
    );
};
